import { useState, createContext, useContext, useCallback } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }, []);

  const remove = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  const icons = {
    success: <CheckCircle size={16} color="#1e8a4a" />,
    error:   <XCircle size={16} color="#c53a2d" />,
    info:    <AlertCircle size={16} color="#173b78" />,
  };

  const colors = {
    success: { border: '#d1fae5', bg: '#f0fdf4' },
    error:   { border: '#fecaca', bg: '#fff5f5' },
    info:    { border: '#bfdbfe', bg: '#eff6ff' },
  };

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div className="toast-container" style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '10px', pointerEvents: 'none' }}>
        {toasts.map(t => {
          const c = colors[t.type] || colors.info;
          return (
            <div key={t.id} style={{
              background: c.bg, border: `1.5px solid ${c.border}`,
              borderRadius: '12px', padding: '12px 16px', display: 'flex',
              alignItems: 'center', gap: '10px', minWidth: '260px', maxWidth: '340px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              animation: 'slideInToast 0.3s cubic-bezier(0.34,1.56,0.64,1)',
              pointerEvents: 'all',
            }}>
              {icons[t.type]}
              <span style={{ flex: 1, fontSize: '13px', fontWeight: 500, color: '#1a1a2e' }}>{t.message}</span>
              <button onClick={() => remove(t.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', display: 'flex', opacity: 0.4 }}>
                <X size={14} color="#6b7280" />
              </button>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
